import React, { useState } from 'react';
import { AddAccountPreSelectionModal } from '../../Features/AccountPreferences/components/AddAccountPreSelectionModal/AddAccountPreSelectionModal';
import { AccountForm } from '../../Features/AccountPreferences/components/AccountForm/AccountForm';
import { ManageAkoyaLinkedAccounts } from '../ManageAkoyaLinkedAccounts/ManageAkoyaLinkedAccounts';
import { QuovoDisabledMessageModal } from '../../../../Quovo/components/QuovoDisabledMessage/QuovoDisabledMessageModal';
import {
  AccountModalUsageContext,
  AccountModalUsageContextOptions,
} from '../../Features/AccountPreferences/components/AccountForm/context/AccountFormProvider.meta';
import { LocalSaveOptions } from '../../Features/AccountPreferences/components/AccountForm/AccountForm.meta';

export enum Selection {
  PreSelection,
  Manual,
  Akkoya,
}

interface Props {
  onClose: () => void;
  showExternalProviders: boolean;
  usageContext?: AccountModalUsageContext;
  usageContextOptions?: AccountModalUsageContextOptions;
  initialSelection?: Selection;
  localSaveOptions?: LocalSaveOptions;
}

export const AddAccountSelectionModalWrapper = ({
  onClose,
  showExternalProviders,
  usageContext,
  usageContextOptions,
  initialSelection,
  localSaveOptions,
}: Props) => {
  const [selection, setSelection] = useState<Selection>(
    initialSelection !== undefined ? initialSelection : Selection.PreSelection,
  );

  const [showQuovoMessage, setShowQuovoMessage] = useState(false);

  if (showQuovoMessage) {
    return <QuovoDisabledMessageModal onRequestClose={() => setShowQuovoMessage(false)} />;
  }

  if (selection === Selection.PreSelection) {
    return (
      <AddAccountPreSelectionModal
        onClose={onClose}
        showQuovoMessage={() => {
          setShowQuovoMessage(true);
        }}
        showExternalProviders={showExternalProviders}
        onManualClick={() => {
          setSelection(Selection.Manual);
        }}
        onOpenAkoyaLinkManagementModal={() => {
          setSelection(Selection.Akkoya);
        }}
      />
    );
  }

  if (selection === Selection.Manual) {
    return (
      <AccountForm
        onClose={onClose}
        usageContext={usageContext}
        usageContextOptions={usageContextOptions}
        localSaveOptions={localSaveOptions}
      />
    );
  }

  return (
    <ManageAkoyaLinkedAccounts
      onClose={onClose}
      onExternalAccountLinked={onClose}
      onBack={() => {
        setSelection(Selection.PreSelection);
      }}
    />
  );
};
